export default __webpack_public_path__ + "static/media/footerBg.58cf53e9.jpg";